import $ from 'jquery';
import { createContext, useContext, useEffect, useState } from "react";

const FormContext = createContext();

export const FormProvider = ({ children }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);

    const openForm = () => setIsFormOpen(true);
    const closeForm = () => setIsFormOpen(false);

    useEffect(() => {
        isFormOpen
            ? $("body").addClass("lock")
            : $("body").removeClass("lock");
    }, [isFormOpen]);

    return (
        <FormContext.Provider value={{ isFormOpen, openForm, closeForm }}>
            {children}
        </FormContext.Provider>
    );
};

export const useForm = () => useContext(FormContext);
